export default __webpack_public_path__ + "static/media/Rectangle18016.a1a4e8cb.png";